import type { ChatRoom, UserChatRoom } from "@/types/chat";

const clean = (value?: string | null): string | null => {
  const trimmed = value?.trim();
  return trimmed ? trimmed : null;
};

export const getChatParticipantLabel = (
  participant?: Pick<UserChatRoom, "name" | "email" | "userId"> | null,
): string | null => {
  return (
    clean(participant?.name) ??
    clean(participant?.email) ??
    clean(participant?.userId)
  );
};

export const getChatRoomDisplayName = (
  room?: Pick<
    ChatRoom,
    "displayName" | "name" | "currentUser" | "otherParticipants" | "userChatRooms"
  > | null,
  fallback = "名称未設定",
): string => {
  const serverDisplayName = clean(room?.displayName);
  if (serverDisplayName) return serverDisplayName;

  const explicitRoomName = clean(room?.name);
  if (explicitRoomName) return explicitRoomName;

  const otherParticipants =
    room?.otherParticipants && room.otherParticipants.length > 0
      ? room.otherParticipants
      : (room?.userChatRooms ?? []).filter((participant) => {
          if (room?.currentUser?.userId) {
            return participant.userId !== room.currentUser.userId;
          }
          return participant.isSelf === false;
        });

  const otherLabels = otherParticipants
    .map((participant) => getChatParticipantLabel(participant))
    .filter((label): label is string => Boolean(label));
  if (otherLabels.length > 0) return otherLabels.join(", ");

  const anyLabels = (room?.userChatRooms ?? [])
    .map((participant) => getChatParticipantLabel(participant))
    .filter((label): label is string => Boolean(label));
  return anyLabels.length > 0 ? anyLabels.join(", ") : fallback;
};

export const getChatRoomInitial = (displayName?: string | null): string => {
  return clean(displayName)?.[0] ?? "?";
};
